/**
 * Nutrio product gallery:
 * - Sync is-active when the main slider moves
 * - Keep gallery height auto to the active image (mixed portrait/landscape media)
 */
(function () {
  const galleries = document.querySelectorAll('.product--nutrio-style media-gallery');
  if (!galleries.length) return;

  function measureSlideHeight(slide, list) {
    if (!slide) return 0;

    const container = slide.querySelector('.product-media-container') || slide;
    const styles = getComputedStyle(container);
    const ratio =
      parseFloat(styles.getPropertyValue('--preview-ratio')) ||
      parseFloat(styles.getPropertyValue('--ratio')) ||
      0;
    const width =
      container.getBoundingClientRect().width ||
      list?.clientWidth ||
      slide.getBoundingClientRect().width ||
      0;

    if (ratio > 0 && width > 0) {
      return Math.ceil(width / ratio);
    }

    const media = slide.querySelector('.media');
    if (media) {
      const paddingTop = parseFloat(getComputedStyle(media).paddingTop);
      if (paddingTop > 0) return Math.ceil(paddingTop);
    }

    return Math.ceil(container.getBoundingClientRect().height);
  }

  function syncGalleryHeight(viewer, slide) {
    const list = viewer.querySelector('.product__media-list');
    if (!list) return;

    const active =
      slide ||
      list.querySelector('.product__media-item.is-active') ||
      list.querySelector('.product__media-item');
    const height = measureSlideHeight(active, list);
    if (height > 40) {
      list.style.height = `${height}px`;
    }
  }

  function bindGallery(gallery) {
    const viewer = gallery.querySelector('[id^="GalleryViewer"]');
    if (!viewer) return;

    const list = viewer.querySelector('.product__media-list');

    const apply = (slide) => {
      if (slide && slide.hasAttribute('data-media-id')) {
        viewer.querySelectorAll('[data-media-id]').forEach((el) => {
          el.classList.toggle('is-active', el === slide);
        });
      }
      syncGalleryHeight(viewer, slide);
    };

    viewer.addEventListener('slideChanged', (event) => {
      apply(event.detail && event.detail.currentElement);
    });

    gallery.querySelectorAll('[id^="GalleryThumbnails"] [data-target]').forEach((thumb) => {
      thumb.addEventListener('click', () => {
        requestAnimationFrame(() => syncGalleryHeight(viewer));
      });
    });

    const refresh = () => syncGalleryHeight(viewer);
    refresh();
    requestAnimationFrame(() => {
      refresh();
      requestAnimationFrame(refresh);
    });

    list?.querySelectorAll('img').forEach((img) => {
      if (img.complete) return;
      img.addEventListener('load', refresh, { once: true });
    });

    window.addEventListener('resize', refresh, { passive: true });
    window.addEventListener('load', refresh, { once: true });
  }

  galleries.forEach(bindGallery);
})();
